/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useRef } from "react";
import { Link } from "react-router-dom";

const menuItems = [
  {
    name: "AILake",
    link: () => {
      return {
        type: "outer",
        url: "https://olake.io/ai-lake",
      };
    },
  },
  {
    name: "OLake",
    subMenu: null,
    link: () => {
      return {
        type: "outer",
        url: "https://olake.io/",
      };
    },
  },
];

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool,
};

const defaultProps = {
  navPosition: "",
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false,
};

const GetProductLink = (item, closeMenu, isOlakePage) => {
  if (item?.subMenu) {
    return <Link to={""}>{item?.name}</Link>;
  }
  const link = item.link(isOlakePage);
  if (link.type === "outer") {
    return (
      <a href={link?.url} target="_blank" rel="noopener noreferrer">
        {item?.name}
      </a>
    );
  } else {
    return (
      <Link to={link?.url} onClick={closeMenu}>
        {item?.name}
      </Link>
    );
  }
};

const UpdatedHeader = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {
  const nav = useRef(null);

  const classes = classNames(
    bottomOuterDivider && "has-bottom-divider",
    className
  );

  return (
    <header {...props} className={`${classes} absolute z-index`}>
      <div className="container header-container">
        <div
          className={classNames(
            "site-header-inner"
          )}
          style={{ flexWrap: "wrap" }}
        >
          <img
            src={require("../../assets/images/datazip-icon.svg")}
            alt="datazip-icon"
            className="datazip-icon"
          />

          {!hideNav && (
            <>
              <nav ref={nav} className={classNames("header-nav")}>
                <div className="header-nav-inner" style={{ flexWrap: "wrap" }}>
                  <ul
                    className={classNames(
                      "list-reset text-xs",
                      navPosition && `header-nav-${navPosition}`
                    )}
                  >
                    {menuItems.map((item, index) => {
                      return <li key={index}>{GetProductLink(item, true)}</li>;
                    })}
                  </ul>
                </div>
              </nav>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

UpdatedHeader.propTypes = propTypes;
UpdatedHeader.defaultProps = defaultProps;

export default UpdatedHeader;
